import React, { createContext, useContext } from 'react';
import { useAuth } from './AuthContext';

const ADMIN_EMAILS = ['studio@faajistudios.com'];

interface AdminContextType {
  isAdmin: boolean;
  adminEmails: string[];
}

const AdminContext = createContext<AdminContextType | undefined>(undefined);

export function AdminProvider({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  
  const isAdmin = user?.email ? ADMIN_EMAILS.includes(user.email) : false;

  return (
    <AdminContext.Provider value={{ isAdmin, adminEmails: ADMIN_EMAILS }}>
      {children}
    </AdminContext.Provider>
  );
}

export function useAdmin() {
  const context = useContext(AdminContext);
  if (context === undefined) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
}

export { ADMIN_EMAILS };
